import OpSearchTable from "./index.vue";
var opsearchtable = {
  install: function install(Vue) {
    Vue.component("OpSearchTable", OpSearchTable);
  }
};
export default opsearchtable;